import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Flex,
  Image,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import TableBookingManagement from "./tableBookingManagement";
import IconFile from "../../assets/images/booking/upfile.svg";
import iconPlus from "../../assets/images/booking/plus.svg";
import PopupImport from "../../components/popup/PopupImport";
import FormDetail from "./form/detail";
import { bookingCall } from "../../api/booking";
import { bookingImageCall } from "../../api/bookingImage";
import toast from "react-hot-toast";
import { exportFile } from "../../utils/tools";
import { useBookingManagement } from "../../hooks/useBookingManagement";
import iconFile from "../../assets/images/apartment/Frame.svg";
import { exportExcelFromApi } from "../../utils/tools";
import iconExcel from "../../assets/images/employee/iconExcel.svg";
import TransactionDetailModal from "../../components/transations/TransactionDetailModal";

const columnMappingReverse = {
  "Tên dự án": "projectName",
  "Mã căn hộ": "apartmentCode",
  "Ngày booking": "bookingTime",
  "Số tiền booking": "price",
  "Ghi chú booking": "note",

  "Tên khách hàng hoặc công ty": "customerName",
  "Mã CCCD": "identificationNumber",
  "Mã số thuế": "businessTaxCode",

  "Tên đại lý": "agentName",
};

export default function BookingManagement() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const transactionModal = useDisclosure();

  const { refetch, isRefetching } = useBookingManagement();

  const [paramExport, setParamExport] = useState(null);
  const [popupVisible, setPopupVisible] = useState(false);
  const [popupImportVisible, setPopupImportVisible] = useState(false);

  const [transactionApprove, setTransactionApprove] = useState({
    id: null,
    type: null,
    status: null,
    submit: null,
  });

  const [confirmLoading, setConfirmLoading] = useState(false);

  useEffect(() => {
    const handleOpenTransactionDetail = (event) => {
      const detail = event.detail || {};

      setTransactionApprove({
        id: detail.id,
        type: detail.type || "BOOKING",
        status: detail.status || "APPROVED",
        submit: detail.submit,
      });

      transactionModal.onOpen();
    };

    window.addEventListener(
      "OPEN_TRANSACTION_DETAIL_MODAL",
      handleOpenTransactionDetail
    );

    return () => {
      window.removeEventListener(
        "OPEN_TRANSACTION_DETAIL_MODAL",
        handleOpenTransactionDetail
      );
    };
  }, [transactionModal]);

  const onSubmitAdd = async (data) => {
    const toastCreate = toast.loading("Đang thêm booking ...");

    try {
      const filteredData = Object.fromEntries(
        Object.entries(data).filter(
          ([_, value]) => value !== "" && value !== undefined && value !== null
        )
      );

      const { delegationImage, ...dataFilter } = filteredData;

      const dataCreateBooking = await bookingCall.create({
        ...dataFilter,
      });

      if (dataCreateBooking?._id) {
        if (delegationImage && delegationImage.length > 0) {
          await bookingImageCall.createMany({
            bookingId: dataCreateBooking?._id,
            path: delegationImage,
            type: "TRANSACTION",
          });
        }
      }

      await refetch();
      onClose();
      toast.success("Thêm thành công");
    } catch (error) {
      console.log({ error });
      toast.dismiss(toastCreate);
    }

    toast.dismiss(toastCreate);
  };

  const handleConfirmTransaction = async ({ refetch: refetchDetail }) => {
    if (!transactionApprove?.submit || !transactionApprove?.id) return;

    setConfirmLoading(true);

    try {
      await transactionApprove.submit(
        transactionApprove.status || "APPROVED",
        transactionApprove.id
      );

      await refetch();

      if (refetchDetail) {
        await refetchDetail();
      }

      transactionModal.onClose();

      setTransactionApprove({
        id: null,
        type: null,
        status: null,
        submit: null,
      });
    } catch (error) {
      console.log("confirm transaction error:", error);
    } finally {
      setConfirmLoading(false);
    }
  };

  const handleExportSample = () => {
    const columnMapping = {
      projectName: "Tên dự án",
      apartmentCode: "Mã căn hộ",
      bookingTime: "Ngày booking",
      price: "Số tiền booking",
      note: "Ghi chú booking",

      customerName: "Tên khách hàng hoặc công ty",
      identificationNumber: "Mã CCCD",
      businessTaxCode: "Mã số thuế",

      agentName: "Tên đại lý",
    };

    const data = [
      {
        projectName: "VINACONEX DIAMOND TOWER",
        apartmentCode: "0601",
        bookingTime: "2024-11-17",
        price: "100,000,000.1",
        note: "abc",
        customerName: "Nguyễn Quốc Đạt",
        identificationNumber: "030200007777",
        agentName: "Đại lý MSH",
      },
      {
        projectName: "VINACONEX DIAMOND TOWER",
        apartmentCode: "0601",
        bookingTime: "2024-11-17",
        price: "100,000,000.1",
        note: "abc",
        customerName: "MSH Group",
        businessTaxCode: "777",
        agentName: "Đại lý MSH",
      },
      {
        projectName: "VINACONEX DIAMOND TOWER",
        apartmentCode: "0601",
        bookingTime: "2024-11-17",
        price: "100,000,000.1",
        note: "abc",
        customerName: "Phạm Đức Trung",
        identificationNumber: "030200001111",
      },
      {
        projectName: "VINACONEX DIAMOND TOWER",
        apartmentCode: "0601",
        bookingTime: "2024-11-17",
        price: "100,000,000.1",
        note: "abc",
        customerName: "MSH Group",
        businessTaxCode: "777",
      },
      {
        projectName: "VINACONEX DIAMOND TOWER",
        apartmentCode: "0601",
        bookingTime: "2024-11-17",
        price: "100,000,000.1",
        note: "abc",
      },
    ];

    try {
      exportFile(data, columnMapping, "bang_booking.xlsx");
      toast.success("Download file thành công");
    } catch (error) {
      toast.error("Export lỗi");
      console.log(error);
    }
  };

  const handleExport = async () => {
    const columnMapping = {
      status: "Trạng thái",
      statusLocking: "Đã lên locking",
      customerName: "Tên khách hàng",
      customerPhone: "SĐT khách hàng",
      apartmentCode: "Mã căn",
      projectName: "Dự án",
      bookingTime: "Ngày booking",
      bookingEvent: "Đợt nhận booking",
      price: "Số tiền booking",
      bookerCode: "Mã nhân viên tạo",
      bookerName: "Tên nhân viên tạo",
      saleBlock: "Khối",
      saleArea: "Vùng",
      createdAt: "thời gian tạo booking",
    };

    await exportExcelFromApi({
      fetcher: () => bookingCall.export(paramExport),
      mapping: columnMapping,
      filename: "bang_quan_ly_booking.xlsx",
      toastMessages: {
        loading: "Đang tải dữ liệu & xuất file...",
        success: "Xuất file thành công",
        noData: "Không có dữ liệu",
        error: "Xuất file thất bại",
      },
    });
  };

  return (
    <Box
      w={{ base: "100%" }}
      backgroundColor="var(--color-backgroundmain)"
      p={{ base: "24px 16px 16px" }}
    >
      <Flex alignItems={"center"} justifyContent={"space-between"}>
        <Flex alignItems={"center"} gap={{ base: "74px" }}>
          <Text fontSize={{ base: "20px" }} fontWeight={600}>
            Quản lý booking
          </Text>
        </Flex>

        <Flex alignItems={"center"} gap={"16px"}>
          <Menu>
            <MenuButton
              w={"180px"}
              h={"44px"}
              as={Button}
              p="10px 16px"
              backgroundImage="var(--color-button)"
              _hover={{
                filter: "brightness(90%)",
              }}
            >
              <Flex alignItems="center" gap="8px" w={"full"}>
                <Image src={IconFile} />
                <Text
                  fontSize="15px"
                  fontWeight={600}
                  color="var(--color-main)"
                >
                  Tải file lên
                </Text>
              </Flex>
            </MenuButton>

            <MenuList>
              <MenuItem
                onClick={() => setPopupVisible(true)}
                gap={"16px"}
                p={"10px 16px"}
                _hover={{
                  filter: "brightness(96%)",
                }}
              >
                <Image src={iconFile} /> Import booking
              </MenuItem>

              <MenuItem
                onClick={() => setPopupImportVisible(true)}
                gap={"16px"}
                p={"10px 16px"}
                _hover={{
                  filter: "brightness(96%)",
                }}
              >
                <Image src={iconFile} /> Import booking Đại lý
              </MenuItem>
            </MenuList>
          </Menu>

          <Button
            w={"176px"}
            h={"44px"}
            display={"flex"}
            alignItems={"center"}
            p={"10px 16px 10px 12px"}
            gap={"8px"}
            background="var(--linear-gradient-employee)"
            _hover={{
              filter: "brightness(90%)",
            }}
            onClick={onOpen}
          >
            <Image src={iconPlus} />
            <Text
              fontSize={{ base: "15px" }}
              fontWeight={600}
              color="var(--color-main)"
            >
              Thêm booking
            </Text>
          </Button>

          <Button
            display={"flex"}
            alignItems={"center"}
            p={"10px 16px 10px 12px"}
            gap={"8px"}
            h={"44px"}
            backgroundImage="var(--linear-gradient-excel)"
            _hover={{
              filter: "brightness(90%)",
            }}
            onClick={handleExport}
          >
            <Image src={iconExcel} />
            <Text
              fontSize={{ base: "15px" }}
              fontWeight={600}
              color="var(--color-main)"
            >
              Xuất dữ liệu booking
            </Text>
          </Button>
        </Flex>
      </Flex>

      <Box mt={{ base: "23px" }}>
        <TableBookingManagement
          isRefetchingWithCreate={isRefetching}
          setParamExport={setParamExport}
        />
      </Box>

      {popupVisible && (
        <PopupImport
          isOpen={popupVisible}
          onClose={() => setPopupVisible(false)}
          refetchCheckInData={refetch}
          columnMappingReverse={columnMappingReverse}
          handleExport={handleExportSample}
          titleAdd="Thêm danh sách booking"
          inputAdd="Nhập danh sách booking"
          type={"bookingImport"}
          isTypePrice={true}
        />
      )}

      {popupImportVisible && (
        <PopupImport
          isOpen={popupImportVisible}
          onClose={() => setPopupImportVisible(false)}
          refetchCheckInData={refetch}
          columnMappingReverse={columnMappingReverse}
          handleExport={handleExportSample}
          titleAdd="Thêm danh sách booking đại lý"
          inputAdd="Nhập danh sách booking đại lý"
          type={"bookingImport"}
          isTypePrice={true}
        />
      )}

      <FormDetail
        isOpen={isOpen}
        onClose={onClose}
        isEdit={false}
        onSubmit={onSubmitAdd}
      />

      <TransactionDetailModal
        isOpen={transactionModal.isOpen}
        onClose={transactionModal.onClose}
        id={transactionApprove.id}
        type={transactionApprove.type}
        onConfirm={handleConfirmTransaction}
        confirmLoading={confirmLoading}
      />
    </Box>
  );
}